import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainComponent} from './main/main.component';
import {FiscaliaModule} from "../fiscalia/fiscalia.module";
import {LibraryRoutingModule} from "./routing.module";

@NgModule({
    imports: [
        CommonModule,
        FiscaliaModule,
        LibraryRoutingModule
    ],
    declarations: [
        MainComponent
    ]
})
export class LibraryModule {
}



// WEBPACK FOOTER //
// ./src/app/library/library.module.ts